import { Box, CircularProgress } from '@mui/material';

import type { Drug } from '@/api/domains/drugs.types';
import { ModalBodyContent } from '@/components/Modal';

import type { NomenclatureModalVariant } from '../types';
import { InstructionForm } from './InstructionForm';
import { useInstruction } from './useInstruction';

export type InstructionTabProps = {
  onClose: VoidFunction;
  drug: Drug;
  variant: NomenclatureModalVariant | null;
};

const LoadingIndicator = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
    <CircularProgress color={'secondary'} />
  </Box>
);

export const InstructionTab = (props: InstructionTabProps) => {
  const { drug } = props;
  const { isInitialLoading, data: instruction } = useInstruction({ drug_id: drug.id });

  if (isInitialLoading) {
    return (
      <ModalBodyContent>
        <LoadingIndicator />
      </ModalBodyContent>
    );
  }

  return <InstructionForm {...props} instruction={instruction?.instruction} />;
};
